module.exports = __webpack_public_path__ + "img/yiduiyi04.5af17153.jpg";